import { SideNav } from 'ui/sideNav';
import { withRouter } from 'react-router';

const linksAndSections = [
  { name: 'All', pathname: '/catalogs' },
  { name: 'Collections', pathname: '/catalogs/collections' },
];

export const NavigationSidebar = () => {
  return <SideNav linksAndSections={linksAndSections} />;
};

export default withRouter(NavigationSidebar);
